module.exports = {
  footerText: 'Copyright Cyber İstanbul A.Ş © 2021',
}
